<template>
  <div class="contact">
    <div class="section-background">
      <div class="container">
        <div
          v-if="loading"
          class="wrapper d-flex align-items-center"
        >
          <div>
            <b-spinner
              variant="primary"
              type="grow"
              label="Loading..."
            />
          </div>
        </div>
        <div
          v-else
          class="wrapper"
        >
          <h1>Payment successful</h1>
          <div class="row">
            <div class="col-sm-auto ">
              <img
                src="../assets/img/congratulations.gif"
                alt="Congratulations"
              >
            </div>
            <div class="col-sm">
              You succsefully hired
              <b>{{ request.coach.firstname }} {{ request.coach.lastname }}</b>
              who will analyse your cricket videos. <br>
              <br>
              <h2>
                Your coupon code is: <br>
                <br>
                <b> {{ request.coupon }}</b>
              </h2>
              <br>
              We sent an email to <b>{{ request.email }}</b> with the needed
              instructions.
              <br>
              <br>
              Have any questions or suggestions? Drop us a line at
              <a href="mailto:hello@ludimos.com">hello@ludimos.com</a>
              <br>
              <br>Thanks {{ request.firstname }} for trusting Ludimos. <br><br>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CoachingService from "@/services/coachingService";
export default {
  name: "PaymentSuccess",
  data() {
    return {
      loading: true,
      sessionId: null,
      request: null
    };
  },
  async created() {
    if (!this.$route.query.session_id) {
      alert("Something went wrong");
    }
    this.loading = true;
    this.sessionId = this.$route.query.session_id;
    await this.getSessionInfo();
  },
  methods: {
    getSessionInfo() {
      CoachingService.fulfillRequest(this.sessionId)
        .then(response => {
          if (response.status === 200) {
            this.request = response.data;
            this.loading = false;
            this.$ma.addTransaction({
              id: `CP-${this.request.coach_profile_id}`,                     
              affiliation: `${this.request.coach.firstname} ${this.request.coach.lastname}`,   
              revenue: this.request.fees,             
              shipping: 0,                  
              tax: 0,
              currency: 'USD'                     
            });
            this.$ma.trackTransaction();
            this.$ma.trackEvent({
              fb_event: "Purchase",
              category: "Purchase",
              action: "Purchase",
              label: `${this.request.coach.firstname} ${this.request.coach.lastname}`,
              type: `${this.request.coach.firstname} ${this.request.coach.lastname}`,
              status: true,
              value: this.request.fees,
              currency: 'USD'
            });
          }
        })
        .catch(() => {
          this.$bvToast.toast("Request failed. Please try again!", {
            title: "Request failure",
            variant: "danger",
            solid: true,
            toaster: "b-toaster-top-center",
            autoHideDelay: "3000"
          });
        });
    }
  },
  metaInfo() {
    return {
      title: this.textEllipsis(`Ludimos - Payment success`, 25),
      // meta: [{ name: "theme-color", content: this.getPrimaryHex }]
    };
  }
};
</script>
<style scoped lang="scss">
.muted {
  opacity: 0.5;
  font-size: 11px;
  display: block;
}
.contact-block {
  text-align: center;

  p {
    margin: 0;
  }
  i {
    font-size: 50px;
    color: #fff;
    margin: 30px 0;
    background: #6f44ff;
    padding: 20px;
    border-radius: 5px;
  }
  a {
    display: block;
  }
}
.contact-map {
  iframe {
    background: #fff;
    padding: 5px;
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
  }
}
</style>
